module.exports = __webpack_public_path__ + "2c1091b7021918e1902c38ea4e0b0354.png";